import classnames from 'classnames';
import React, { DetailedHTMLProps, ButtonHTMLAttributes } from 'react';

import AccountSelectorLayout, { AccountSelectorLayoutProps } from './AccountSelectorLayout';

interface RowButtonComposition {
    AccountSelectorLayout: React.FC<AccountSelectorLayoutProps>;
}

const RowButton: React.FC<DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>> &
    RowButtonComposition = ({ className, children, ...otherProps }) => (
    <button type="button" className={classnames('row-button__container', className)} {...otherProps}>
        {children}
    </button>
);

RowButton.AccountSelectorLayout = AccountSelectorLayout;

export default RowButton;
